import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faCheck, faCircleCheck } from '@fortawesome/free-solid-svg-icons'

import CardDay from '@/components/CardDay/index.vue'

library.add(faCheck, faCircleCheck)

@Component({
	components: {
		CardDay,
	},
})
export default class WrapperWeek extends Vue {
	@Prop() readonly week
	@Prop() readonly height
}
